import { useState } from 'react';
import { TNullable } from '../common/types';

function useLocalStorage<T>(keyName: string, defaultValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value) as T;
      }
      if (defaultValue !== null) {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
      }
      return defaultValue;
    } catch (_) {
      return defaultValue;
    }
  });

  function setValue(newValue: TNullable<T>) {
    try {
      if (newValue === null) window.localStorage.removeItem(keyName);
      else window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {
      console.warn(err);
    }
    setStoredValue(newValue as T);
  }

  return [storedValue, setValue] as const;
}

export default useLocalStorage;
